// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"192":"stand","443":"about"}[chunkId] || chunkId) + "." + {"18":"06b5cdea","111":"4d20b9d1","192":"c45a1580","328":"56c3c5db","443":"aef2684c","743":"984e0e75","877":"d6d7cffb","904":"e0573200"}[chunkId] + ".css";
};